/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useAppStore } from "../store/models/app";
import {  getElementFromSelector } from './utils/css';

function makeWidgetTheme (widget, customCss) {

    const multipliers = {
        paddingDefault: '1rem',
        default: 1.2,
        large: 1.2 * 1.5,
        small: 1.2 / (1.2 * 1.5),
        largePercentage:  (1.2 * 1.5) * .1,
    };

    const defaultStatics = {
        padding: multipliers.paddingDefault,
        paddingSmall: `calc(${multipliers.paddingDefault} / ${multipliers.default})`,
        paddingLarge: `calc(${multipliers.paddingDefault} * ${multipliers.default})`,
        paddingExtraLarge:  `calc(${multipliers.paddingDefault} * ${multipliers.default} * ${multipliers.large}  )`,

        grey3: '#dfe4e7',
        grey4: '#f2f2f2',
        borderWidth: '1px',
        borderStyle: 'solid',
        baseFontWeight: 350,
        lineHeight: '1.5em',
    };

    const widgetTheme = {
        defaultStatics,
        ...defaultStatics,
        hasCustomCSS: customCss,
    };
    return widgetTheme;
}

function hasCustom ({ widgetTheme, className, styleName }) {

  if (!widgetTheme.cssCustomClasses) {
    return false;
  }

  const cls = widgetTheme.cssCustomClasses[className];
  if (cls && cls.indexOf(styleName) !== -1) {
    return true;
  }
  return false;
}

function hasCustomClass ({ widgetTheme, className }) {
    if (!widgetTheme.cssCustomClasses) {
        return false;
    }
    const cls = widgetTheme.cssCustomClasses[className];
    if (cls) {
        return true;
    }
    return false;
}

function useWidgetTheme (p = {}) {

    const {
        selector = null,
        styleFallback = () => {}
    } = p;

    const appStore = useAppStore();

    const [widgetTheme, setWidgetTheme] = useState(makeWidgetTheme(appStore.widget, appStore.customCss));
    const [cssCustomClasses, setCssCustomClasses] = useState(appStore.cssCustomClasses);
    const [hasCustomCSS , setHasCustomCSS] = useState(appStore.customCss);
    const [widget, setWidget] = useState(appStore.widget);
    useEffect(() => {
        setWidgetTheme(makeWidgetTheme(appStore.widget));
        setWidget(appStore.widget);
    }, [appStore.observed.widget]);

    useEffect(() => {
        // console.log('customCSS updated...', appStore.cssCustomClasses);
        setCssCustomClasses(appStore.cssCustomClasses);
        setHasCustomCSS(appStore.customCss);
        setWidgetTheme({
            ...widgetTheme,
            hasCustomCSS: appStore.customCss,
            cssCustomClasses: appStore.cssCustomClasses,
            hasCustom,
            hasCustomClass,
        });
        if (appStore.observed.customCss) {
            getElement();
        }
    }, [appStore.observed.customCss]);

    async function getElement () {
        let el = null;
        if (selector) {
            el = await getElementFromSelector(selector);

            if (typeof styleFallback === 'function') {
                styleFallback({
                    element: el,
                    setWidgetTheme,
                    widgetTheme,
                    widget: appStore.widget,
                    computedStyle: window.getComputedStyle(el),
                });
            }
        } 
    }

    return {
        appStore,
        widgetTheme,
        widget,
        hasCustomCSS,
        cssCustomClasses,
    };
}


export default useWidgetTheme;